/* Lifecycle for Smile Pro editorial videos; product-gallery playback stays with Shopify. */
(()=>{
  function init(){
    const videos=[...document.querySelectorAll('video[data-smile-video]')];
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    const state=new Map(videos.map(video=>[video,{visible:false,auto:video.dataset.smileAutoplay==='true',userPaused:false,resume:false,internalPause:false}]));
    function load(video){
      let changed=false;
      video.querySelectorAll('source[data-smile-src]').forEach(source=>{source.src=source.dataset.smileSrc;source.removeAttribute('data-smile-src');changed=true;});
      if(changed)video.load();
    }
    function play(video){load(video);const promise=video.play();if(promise)promise.catch(()=>{});}
    function sync(video){
      const s=state.get(video);
      if(!s.visible||document.hidden){if(!video.paused){s.resume=true;s.internalPause=true;video.pause();}return;}
      if(s.auto&&reduced.matches)return;
      if(!s.userPaused&&((s.auto&&!reduced.matches)||s.resume)){s.resume=false;play(video);}
    }
    videos.forEach(video=>{
      const s=state.get(video);
      video.removeAttribute('autoplay');
      video.preload='none';
      if(reduced.matches&&s.auto)video.controls=true;
      video.addEventListener('pause',()=>{if(s.internalPause){s.internalPause=false;return;}if(s.visible&&!document.hidden)s.userPaused=true;});
      video.addEventListener('play',()=>{s.userPaused=false;if(!s.visible||document.hidden)sync(video);});
      // Controls videos have a regular source and preload=none, allowing native play/seek.
    });
    if('IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{const s=state.get(entry.target);s.visible=entry.isIntersecting&&entry.intersectionRatio>=.2;sync(entry.target);}),{threshold:[0,.2]});
      videos.forEach(video=>observer.observe(video));
    }else{videos.forEach(video=>{const s=state.get(video);s.visible=true;video.controls=true;load(video);});}
    document.addEventListener('visibilitychange',()=>videos.forEach(sync));
    reduced.addEventListener('change',()=>videos.forEach(video=>{const s=state.get(video);if(s.auto){video.controls=reduced.matches;if(reduced.matches&&!video.paused){s.internalPause=true;video.pause();}else sync(video);}}));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
